<template>
  <v-app>
    <WarningEnvironment v-if="showWarning"/>
    <v-main
      id="mainContent"
      :class="{
        'whiteBG': !$store.getters.isLoggedIn,
        'blueBG': $store.getters.isLoggedIn
      }"
      :style="{'overflow-y': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 'auto' : 'hidden'}"
    >
      <TheSideBar v-if="$store.getters.isLoggedIn"/>
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view isLoggedIn="isLoggedIn"></router-view>
        <!-- <v-btn
          style="bottom: 1%"
          absolute
          fab
          bottom
          right
        >
          <v-icon x-large>mdi-help</v-icon>
        </v-btn> -->
        <v-fab-transition v-if="$store.getters.isLoggedIn && $vuetify.breakpoint.mdAndUp">
          <v-btn
            v-if="showHelpButon"
            fab
            fixed
            right
            bottom
            raised
            dark
            color="#FB8C00"
            elevation="15"
            class="v-btn--help"
            @click="dialog = true"
            id="btn-help"
          >
            <v-icon large>mdi-help</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
    </v-main>
    <TheFooter />
    <v-dialog v-if="$vuetify.breakpoint.mdAndUp" scrollable width="90%" v-model="dialog">
      <Help :dialog.sync="dialog"/>
    </v-dialog>
  </v-app>
</template>

<script>
import TheFooter from './components/TheFooter'
import WarningEnvironment from './components/WarningEnvironment'
import TheSideBar from '@/components/TheSideBar'
import Help from '@/components/Helpers/Help'
import SessionService from '@/services/SessionService'

export default {
  name: 'App',
  components: {
    TheFooter,
    WarningEnvironment,
    TheSideBar,
    Help
  },
  data () {
    return {
      dialog: false,
      showHelpButon: false
    }
  },
  async mounted () {
    try {
      this.watchSession()
      this.animateHelpButton()
      this.animateWarning()
    } catch (error) {
      console.info(error)
    }
  },
  methods: {
    async watchSession () {
      setInterval(async () => {
        if (this.$store.getters.isLoggedIn) {
          let isLoggedIn, user
          try {
            const { data } = await SessionService.getSession()
            if (data) {
              user = data.user
              isLoggedIn = data.isLoggedIn
            }
          } catch (error) {
            console.error(error)
          }
          this.$store.dispatch('setUser', {
            isLoggedIn: isLoggedIn || false,
            user: user || {}
          })
          if (!user || !user.active || !isLoggedIn) {
            this.$router.push({ name: 'logout' })
          }
        }
      }, 300000)
    },

    animateHelpButton () {
      var self = this
      setTimeout(async function () {
        self.showHelpButon = true

        const buttonToAnimate = document.getElementById('btn-help')
        if (buttonToAnimate) {
          if (buttonToAnimate.classList) {
            await buttonToAnimate.classList.toggle('animated-button-help')
          } else {
            // For IE9
            var classes = buttonToAnimate.className.split(' ')
            var i = classes.indexOf('animated-button-help')

            if (i >= 0) {
              classes.splice(i, 1)
            } else {
              classes.push('animated-button-help')
              buttonToAnimate.className = classes.join(' ')
            }
          }
        }
      }, 4000)
    },

    animateWarning () {
      setInterval(async function () {
        const buttonToAnimate = document.getElementById('warning-text')
        if (buttonToAnimate) {
          if (buttonToAnimate.classList) {
            await buttonToAnimate.classList.toggle('animated-text')
          } else {
            // For IE9
            var classes = buttonToAnimate.className.split(' ')
            var i = classes.indexOf('animated-text')

            if (i >= 0) {
              classes.splice(i, 1)
            } else {
              classes.push('animated-text')
              buttonToAnimate.className = classes.join(' ')
            }
          }
        }
      }, 4000)
    }
  },

  computed: {
    showWarning () {
      return !(process.env.VUE_APP_BLUENV === 'production' || process.env.VUE_APP_BLUENV === 'development')
    }
  }
}
</script>
<style>
  .v-btn--help {
    bottom: 30px !important;
    margin: 0 0 16px 16px;
  }
  .whiteBG {
    background: white;
  }
  .blueBG {
    background: #46659B;
  }
  .special-checkbox {
    -ms-transform: scale(1.4); /* IE */
    -moz-transform: scale(1.4); /* FF */
    -webkit-transform: scale(1.4); /* Safari and Chrome */
    -o-transform: scale(1.4); /* Opera */
    transform: scale(1.4);
  }
  .active-chip {
    background-color: #5C9DF2 !important;
    border-color: #5C9DF2 !important;
    color: white !important;
    font-weight: bolder;
    font-size: 18px !important;
  }
  .inactive-chip {
    background-color: white !important;
    border-color: white !important;
    color: #5C9DF2!important;
    font-weight: bolder;
    font-size: 18px !important;
  }
  .v-data-table tbody tr {
    background-color: white !important;
    color: #0420BF !important;
  }
  .horizontal-padding-content {padding-right: 2% !important; padding-left: 2% !important;}

  .small-suffix .v-text-field__suffix {
    font-size: 11px !important;
    color: #0420BF;
    font-weight: bolder;
  }
  .special-button .v-btn__content {
    font-size: 10px!important;
    font-weight: 800!important;
  }
  .v-item--active {
    background-color: white;
  }
  .close-button {
    background-color: #0420BF !important;
    color: white !important;
  }
  .v-expansion-panel-content__wrap {
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-bottom: 0px !important;
  }
  .center-input {
    text-align: center!important;
  }
  .center-input input {
    text-align: center!important;
  }
  .automaticPayment {
    text-transform: capitalize;
    color: #004D40;
    font-weight: bold;
    font-size: smaller;
  }
  .animated-text {
    -webkit-animation-name: shakeX;
    -webkit-animation-duration: 1.5s;
    -webkit-animation-iteration-count: 1;
    -webkit-animation-delay: 0s;
  }
</style>
